const AppContext = React.createContext();

export default AppContext;
